import React from 'react';
import { getElevateBadges } from './helpers/getElevateBagdes';
import { styled } from 'linaria/react';
import Badges from '@jetshop/ui/ProductList/Badges';
import { theme } from '../Theme';

const BadgesWrapper = styled('div')`
  position: absolute;
  top: 10px;
  bottom: 10px;
  width: 100%;
  right: 0;
  z-index: 2;

  > div > div {
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 0.55rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      line-height: 1;
      text-align: center;
      width: 73px;
      height: 25px;
      color: white;
      margin-bottom: 5px;
      background: #0c3721;

      &.sale-tagg {
        background: #872c2b;
      }

      &.member-tagg {
        background: #b08832;
      }

      &.best-price-tagg {
        background: #ef7622;
      }

      &.new-tagg {
        background: #000;
      }

      &.new-new-tagg {
        background: #0c3721;
      }

      &.member-deal-tagg {
        background: ${theme.colors.pink};
      }

      &.green-tag {
        background: #0d3923;
      }

      &.mips {
        background: #fefd32;
        color: black;
      }
    }
  }
`;

export const ElevateCardBadge = ({ product }) => {
  const badges = getElevateBadges(product);
  if (!badges.length) return null;

  return (
    <BadgesWrapper className="badges-wrapper">
      <Badges badges={badges} />
    </BadgesWrapper>
  );
};
